const api = '/cms-service/api/external/seoTags';

export const seoTagsContext = {
  all: `${api}`,
  filter: `${api}/filter`,
  byId: `${api}/{id}`,
};
